module.exports = __webpack_public_path__ + "static/media/logo-bravo-club@2x.800e8a9d.png";